import React, { useEffect, useState } from 'react'
import { FaEye, FaEyeSlash } from 'react-icons/fa6'
import { FcGoogle } from 'react-icons/fc'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import resumeImg from '../assets/resume.svg'
import { FaGithub, FaRegFileAlt } from 'react-icons/fa'
import { supabase } from '../lib/util'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useForm } from 'react-hook-form'


const Signin = () => {
    const [formData, setFormData] = useState({
        email: '',
        password: ''
    })
    const { register, handleSubmit, formState: { errors } } = useForm();

    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);

    // Function to toggle password visibility
    const togglePasswordVisibility = () => {
        setShowPassword((prevState) => !prevState);
    };


    const location = useLocation();
    const fromPreviewLayout = location?.state?.fromPreviewLayout;
    const fromSignUp = location?.state?.fromSignUp;

    useEffect(() => {
        if (fromSignUp) {
            toast("We've sent a verification link to your email. Please check your inbox and click the link to verify your account")

        }
    }, [fromSignUp])



    async function signInNewUser(e) {
        // e.preventDefault()

        try {
            const { data, error, } = await supabase.auth.signInWithPassword({
                email: formData.email,
                password: formData.password,

            })

            if (error) {
                throw new Error(error)
            }


            if (data) {

                navigate("/", {

                })
            }
        } catch (error) {
            const errorArray = error.message.split(":")
            const errorMsg = errorArray.length > 1 ? errorArray[1] : error.message
            toast(errorMsg)
        }
    }

    const handleOnChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        })
    }

    let domainUrl = process.env.REACT_APP_DOMAIN_URL;
    if(fromPreviewLayout){
        domainUrl += '/resume-builder'
    } else{
        domainUrl += '/'
    }
    const handleAuthLogin = async (provider) => {
        await supabase.auth.signInWithOAuth({
            provider: provider,
            options: {

                redirectTo:domainUrl
            }
        })
    }





    return (
        <div className='relative w-full flex h-full'>

            <div className='relative hidden md:flex items-center flex-col justify-center w-1/2 h-screen bg-gradient-to-b from-blue-500 to-blue-600'>
                <div className='text-white absolute inset-5'>
                    <Link to='/' className='flex items-center'>
                        <div className='text-xl mx-1'>
                            <FaRegFileAlt />

                        </div>
                        <h1 className='text-xl font-semibold'>ResumeCraftr</h1>
                    </Link>
                </div>


                {/* <div className=' mx-auto text-white text-xl'>ResumeCraftr</div> */}
                <h1 className='text-white text-4xl font-semibold'>{"Craft Your Professional Story"}</h1>
                <h2 className='text-white/80 text-lg'>{fromPreviewLayout ? "You're just one step away from downloading your professional resume!" : "Your next opportunity starts here. Let’s make it happen together!"}</h2>
                <img src={resumeImg} alt="" className='h-64 mt-5' />

            </div>

            <div className='md:w-1/2 flex flex-col justify-center h-screen max-w-xs md:max-w-md  mx-auto'>
                <div className='md:hidden absolute inset-4 z-20 pointer-events-none text-sky-600'>
                    <Link to='/' className='flex items-center'>
                        <div className='text-lg mx-1'>
                            <FaRegFileAlt />

                        </div>
                        <h1 className='text-lg font-semibold'>ResumeCraftr</h1>
                    </Link>
                </div>

                <h1 className={`text-center ${fromPreviewLayout ? 'text-2xl' : 'text-3xl'} py-4 font-semibold`}>{fromPreviewLayout ? "Sign In to Download Your Resume" : "Login to your account"}</h1>
                <div className='flex justify-between'>
                    <button className='border mx-1 rounded-sm border-black/30 px-16 md:px-24 py-2' onClick={() => handleAuthLogin("google")}><FcGoogle className='md:text-lg' /></button>
                    <button className='border mx-1 rounded-sm border-black/30 px-16 md:px-24 py-2' onClick={() => handleAuthLogin("github")}><FaGithub className='md:text-lg' /></button>
                </div>
                <div className="relative mt-4">
                    <div className="absolute inset-0 flex items-center">
                        <span className="w-full border-t"></span>
                    </div>
                    <div className="relative flex justify-center text-sm">
                        <span className="px-2 bg-white text-gray-700">
                            Or use e-mail address
                        </span>
                    </div>
                </div>
                <form onSubmit={handleSubmit(signInNewUser)} className='flex flex-col mt-4'>
                    <label htmlFor="" className='mt-3 text-lg'>Email</label>
                    <input type="email" placeholder='Enter your email' className='border px-3 py-2 my-2'
                        {...register('email', {
                            value: formData?.email,
                            required: true,
                            pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                            onChange: (e) => handleOnChange(e)
                        })} />
                    {errors.email && <p className="text-red-500 text-xs italic">Please enter a valid email address</p>}

                    <label htmlFor="" className='mt-3 text-lg'>Password</label>
                    <div className='relative my-2 flex items-center'>
                        <input type={showPassword ? "text" : "password"} placeholder='Enter your password' className='relative w-full border px-3 py-2 '
                            {...register('password', {
                                value: formData?.password,
                                required: true,
                                minLength: 8,
                                pattern: /^(?=.*[A-Za-z])(?=.*\d).{6,}$/,
                                onChange: (e) => handleOnChange(e)

                            })} />
                        <div className='absolute right-3 text-lg cursor-pointer' onClick={togglePasswordVisibility}>
                            {showPassword ? <FaEye /> : <FaEyeSlash />}
                        </div>
                    </div>

                    {
                        errors.password && (
                            <p className="text-red-500 text-xs italic">
                                Password must be at least 6 characters long and include at least one letter and one number.
                            </p>
                        )}

                    <div className="flex items-center justify-end my-4">
                        {/* <div className="flex items-center space-x-2 ">
                            <input type='checkbox' id="remember" />
                            <label
                                htmlFor="remember"
                                className="text-sm text-gray-500 leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                            >
                                Remember me
                            </label>
                        </div> */}
                        {/* <Link
                            href="/forgot-password"
                            className="text-sm text-sky-600 hover:text-sky-500 font-medium"
                        >
                            Forgot password?
                        </Link> */}
                    </div>
                    <button type='submit'
                        className="w-full h-12 bg-gray-600 hover:bg-gray-700 text-white"
                    >
                        {fromPreviewLayout ? "Sign In & Download" : "Login now"}
                    </button>
                </form>
                <p className="text-center text-gray-600 mt-6">
                    Don't have an account?{" "}
                    <Link to="/signup" state={{ fromPreviewLayout }} className="text-sky-600 hover:text-sky-500 font-medium">
                        Join free today
                    </Link>
                </p>
                {/* <div className='text-center mt-2 flex items-center w-full mx-auto'> <div className='h-1 bg-black w-full'></div> <span className='w-1/2'>Or use e-mail address</span> <div className='h-1 bg-black w-full'></div></div> */}
            </div>
            <ToastContainer />

        </div>
    )
}

export default Signin